if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();

        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');

        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');

        this.eventMouseEnterHappened = false;

        this._onDocPointerDown = this._onDocPointerDown.bind(this);
        this._onKeyUp = this._onKeyUp.bind(this);
        this._onMouseLeavePopover = this._onMouseLeavePopover.bind(this);
      }

      connectedCallback() {
        // Close on outside click/tap (prevents popovers getting “stuck” after DOM swaps)
        document.addEventListener('pointerdown', this._onDocPointerDown, true);

        // Close on Escape (works from anywhere inside the popover)
        this.addEventListener('keyup', this._onKeyUp);

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.mqlTablet.matches) {
          this.popoverInfo.addEventListener('mouseleave', this._onMouseLeavePopover);
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this._onDocPointerDown, true);
        this.removeEventListener('keyup', this._onKeyUp);

        try {
          this.popoverInfo?.removeEventListener('mouseleave', this._onMouseLeavePopover);
        } catch (e) {}
      }

      _onMouseLeavePopover(e) {
        this.closePopover(e);
      }

      _onKeyUp(e) {
        if (e.key === 'Escape') this.closePopover(e);
      }

      _onDocPointerDown(e) {
        // If click/tap happens outside this component, close.
        if (!this.contains(e.target)) {
          this.closePopover();
        }
      }

      getActiveButton() {
        return this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
      }

      isOpen() {
        const button = this.getActiveButton();
        return button && button.getAttribute('aria-expanded') === 'true';
      }

      togglePopover(event) {
        if (event) event.preventDefault();

        if (event && event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        // Prevent click firing immediately after hover-open (keeps desktop stable)
        if (event && event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.getActiveButton();
        if (!button || !this.popoverInfo) return;

        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        // Desktop hover should only OPEN. Click toggles.
        if ((this.mql.matches && !isExpanded) || (event && event.type === 'click')) {
          button.setAttribute('aria-expanded', String(!isExpanded));
          this.popoverInfo.toggleAttribute('hidden', isExpanded);
          button.classList.toggle('quantity-popover__info-button--open', !isExpanded);

          // Keep existing animation hook
          if (this.infoButtonDesktop) {
            this.infoButtonDesktop.classList.add('quantity-popover__info-button--icon-only--animation');
          }
        }

        // If opened by click, keep focus sensible
        if (button.getAttribute('aria-expanded') === 'true' && (!event || event.type !== 'mouseenter')) {
          try {
            button.focus();
          } catch (e) {}
        }
      }

      closePopover(event) {
        if (event && typeof event.preventDefault === 'function') event.preventDefault();

        const button = this.getActiveButton();
        if (!button || !this.popoverInfo) return;

        // If focus is moving between button and popover, don't close.
        const related = event && event.relatedTarget ? event.relatedTarget : null;
        const isButtonChild = related && this.infoButtonDesktop ? this.infoButtonDesktop.contains(related) : false;
        const isPopoverChild = related && this.popoverInfo.contains(related);

        if (!related || (!isButtonChild && !isPopoverChild)) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');

          if (this.infoButtonDesktop) {
            this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
          }
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}
